import { createSlice } from "@reduxjs/toolkit";
import { ehrAction } from "../actions/ehrAction";

const initialState = {
  activeEHRJobsTab: "",
};

const ehrSlice = createSlice({
  name: "ehrJobs",
  initialState,
  reducers: ehrAction,
});

export const { changeActiveEHRJobsTab } = ehrSlice.actions;
export default ehrSlice.reducer;
